const user = {
    username_already_in_use: 'ชื่อผู้ใช้นี้ถูกใช้ไปแล้ว',
    username_starts_with_number: 'ชื่อผู้ใช้ต้องไม่เริ่มต้นด้วยตัวเลข',
    username_invalid_charset_hard: 'ชื่อผู้ใช้สามารถประกอบด้วยตัวอักษร ตัวเลข และขีดล่างเท่านั้น',
    username_too_short: 'ชื่อผู้ใช้สั้นเกินไป',
    username_too_long: 'ชื่อผู้ใช้ยาวเกินไป',
    username_uppercase_not_allowed: 'ชื่อผู้ใช้ต้องไม่มีตัวอักษรตัวใหญ่',
    username_lowercase_not_allowed: 'ชื่อผู้ใช้ต้องไม่มีตัวอักษรตัวเล็ก',
    username_numbers_not_allowed: 'ชื่อผู้ใช้ต้องไม่มีตัวเลข',
    username_underscore_not_allowed: 'ชื่อผู้ใช้ต้องไม่มีขีดล่าง',
    email_already_in_use: 'อีเมลนี้ถูกเชื่อมโยงกับบัญชีที่มีอยู่แล้ว',
    phone_already_in_use: 'เบอร์โทรศัพท์นี้ถูกเชื่อมโยงกับบัญชีที่มีอยู่แล้ว',
    invalid_email: 'ที่อยู่อีเมลไม่ถูกต้อง',
    invalid_phone: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
    email_not_exist: 'ที่อยู่อีเมลนี้ยังไม่ได้ลงทะเบียน',
    phone_not_exist: 'หมายเลขโทรศัพท์นี้ยังไม่ได้ลงทะเบียน',
    identity_not_exist: 'บัญชีโซเชียลนี้ยังไม่ได้ลงทะเบียน',
    sso_identity_not_exist: 'บัญชี SSO ขององค์กรยังไม่ได้ลงทะเบียน',
    identity_already_in_use: 'บัญชีโซเชียลนี้ถูกเชื่อมโยงกับบัญชีที่มีอยู่แล้ว',
    social_account_exists_in_profile: 'คุณได้เชื่อมโยงบัญชีโซเชียลนี้แล้ว',
    cannot_delete_self: 'คุณไม่สามารถลบบัญชีของตัวเองได้',
    sign_up_method_not_enabled: 'ยังไม่ได้เปิดใช้งานวิธีสมัครนี้',
    sign_in_method_not_enabled: 'ยังไม่ได้เปิดใช้งานวิธีเข้าสู่ระบบนี้',
    same_password: 'รหัสผ่านใหม่ต้องไม่เหมือนกับรหัสผ่านเก่า',
    password_required_in_profile: 'คุณต้องตั้งค่ารหัสผ่านก่อนเข้าสู่ระบบ',
    new_password_required_in_profile: 'คุณต้องตั้งค่ารหัสผ่านใหม่',
    password_exists_in_profile: 'โปรไฟล์ของคุณมีรหัสผ่านแล้ว',
    username_required_in_profile: 'คุณต้องตั้งค่าชื่อผู้ใช้ก่อนเข้าสู่ระบบ',
    username_exists_in_profile: 'โปรไฟล์ของคุณมีชื่อผู้ใช้อยู่แล้ว',
    email_required_in_profile: 'คุณต้องเพิ่มอีเมลก่อนเข้าสู่ระบบ',
    email_exists_in_profile: 'โปรไฟล์ของคุณได้เชื่อมโยงกับอีเมลแล้ว',
    phone_required_in_profile: 'คุณต้องเพิ่มเบอร์โทรศัพท์ก่อนเข้าสู่ระบบ',
    phone_exists_in_profile: 'โปรไฟล์ของคุณได้เชื่อมโยงกับเบอร์โทรศัพท์แล้ว',
    email_or_phone_required_in_profile: 'คุณต้องเพิ่มอีเมลหรือเบอร์โทรศัพท์ก่อนเข้าสู่ระบบ',
    suspended: 'บัญชีนี้ถูกระงับ',
    user_not_exist: 'ไม่พบบัญชีผู้ใช้ที่มี {{ identifier }}',
    missing_profile: 'คุณต้องระบุข้อมูลเพิ่มเติมก่อนเข้าสู่ระบบ',
    role_exists: 'รหัสบทบาท {{roleId}} ได้ถูกเพิ่มให้กับผู้ใช้นี้แล้ว',
    invalid_role_type: 'ประเภทบทบาทไม่ถูกต้อง ไม่สามารถกำหนดบทบาทเครื่องจักรกับผู้ใช้ได้',
    suggest_mfa: 'เพื่อความปลอดภัยของบัญชีที่ดียิ่งขึ้น เราแนะนำให้ผูก MFA กับบัญชีของคุณ',
    missing_mfa: 'คุณต้องผูก MFA เพิ่มเติมก่อนเข้าสู่ระบบ',
    totp_already_in_use: 'TOTP นี้ถูกใช้ไปแล้ว',
    backup_code_already_in_use: 'รหัสสำรองนี้ถูกใช้ไปแล้ว',
    password_algorithm_required: 'ต้องระบุอัลกอริทึมของรหัสผ่าน',
    password_and_digest: 'ไม่สามารถตั้งค่ารหัสผ่านธรรมดาร่วมกับรหัสผ่านที่เข้ารหัสได้',
    personal_access_token_name_exists: 'มีชื่อ Personal access token นี้แล้ว',
    totp_secret_invalid: 'รหัสลับ TOTP ไม่ถูกต้อง',
    wrong_backup_code_format: 'รูปแบบรหัสสำรองไม่ถูกต้อง',
    username_required: 'ชื่อผู้ใช้เป็นข้อมูลบังคับ ไม่สามารถตั้งค่าเป็นค่าว่างได้',
    email_or_phone_required: 'ที่อยู่อีเมลหรือหมายเลขโทรศัพท์เป็นข้อมูลบังคับ ต้องมีอย่างน้อยหนึ่งอย่าง',
    last_sign_in_method_required: 'คุณต้องมีวิธีลงชื่อเข้าใช้ที่ใช้งานได้อย่างน้อยหนึ่งวิธีในบัญชีของคุณ',
    email_required: 'ที่อยู่อีเมลเป็นข้อมูลบังคับ ไม่สามารถตั้งค่าเป็นค่าว่างได้',
    phone_required: 'หมายเลขโทรศัพท์เป็นข้อมูลบังคับ ไม่สามารถตั้งค่าเป็นค่าว่างได้',
    enterprise_sso_identity_not_exists: 'ผู้ใช้ยังไม่ได้เชื่อมโยงข้อมูลองค์กรกับ SSO connector ID ที่ระบุ: {{ ssoConnectorId }}',
    identity_not_exists_in_current_user: 'ไม่พบข้อมูลบัญชีที่ระบุในบัญชีผู้ใช้นี้ กรุณาเชื่อมโยงบัญชีก่อนดำเนินการต่อ',
    passkey_preferred: 'สร้าง passkey เพื่อทำให้ขั้นตอนการเข้าสู่ระบบง่ายขึ้น',
};
export default Object.freeze(user);
